import React from 'react'

const ComprasLista = () => {
  return (
    <>
      <h1>Lista de compras</h1>
    </>
  )
}

export default ComprasLista
